import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EProductExpansionEntryPoint } from '@api-ui-app/src/app/header-create-menu/types/upload-click-from.enum';

@Injectable({
  providedIn: 'root',
})
export class ProductExpansionHistory {
  readonly navigatedFrom$ = new BehaviorSubject<string>('/');
  readonly entryPoint$: BehaviorSubject<EProductExpansionEntryPoint | null> =
    new BehaviorSubject<EProductExpansionEntryPoint>(null);

  setNavigateFrom(from: string): void {
    this.navigatedFrom$.next(from);
  }

  setEntryPoint(entryPoint: EProductExpansionEntryPoint) {
    this.entryPoint$.next(entryPoint);
  }
}
